import { makeObservable, observable, action } from 'mobx';
import { createContext } from 'react';

class LayoutStore {
  hideMenuEntries = false;
  location = null;
  slug = null;

  constructor() {
    makeObservable(this, {
      hideMenuEntries: observable,
      location: observable,
      slug: observable,
      setHideMenuEntries: action,
      setCurrentLocation: action,
      setSlug: action,
    });
  }

  setCurrentLocation(location) {
    this.location = location;
  }

  setHideMenuEntries(hideMenuEntries) {
    this.hideMenuEntries = hideMenuEntries;
  }

  setSlug(slug) {
    this.slug = slug;
  }
}

const layoutStore = new LayoutStore();
export default layoutStore;

export const LayoutContext = createContext();
